<template>
  <urun-areas-layout>
    <div>
      <div class="mb-3">
        <div>
          <panel-title
            icon="mdi-label"
            :title="$t('URUNLER.PRODUCT_PREFERENCES.PRODUCT_TYPES_AREA.TITLE')"
            :desc="$t('URUNLER.PRODUCT_PREFERENCES.PRODUCT_TYPES_AREA.SUB_TITLE')"
          >
            <template v-slot:append-inner>
              <v-btn color="grey darken-3" class="text-capitalize" small dark @click="urunTuruEkle.dialog = true" :loading="!turStatus">
                <v-icon size="18" left>mdi-plus-box</v-icon>
                {{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_TYPES_AREA.ADD_NEW_PRODUCT_TYPE_BTN") }}
              </v-btn>
            </template>
          </panel-title>
        </div>
      </div>
      <div>
        <div v-if="!urunTurleriListesi.length && !turStatus">
          <v-skeleton-loader :key="key" v-for="key in 3" class="mb-4" elevation="1" type="article"></v-skeleton-loader>
        </div>
        <div v-else-if="!urunTurleriListesi.length && turStatus">
          <p class="body-2 font-weight-medium text-center grey--text text--darken-1 py-3 px-3 grey lighten-2">
            {{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_TYPES_AREA.NO_PRODUCT_TYPE_ADDITIONAL") }}
          </p>
        </div>
        <v-card v-else class="px-4 py-4 mb-3" :key="key" v-for="(tur, key) in urunTurleriListesi">
          <div class="d-flex justify-space-between align-center mb-3">
            <h2 class="d-flex align-center body-1 font-weight-bold">
              <v-icon color="grey darken-3" size="20" left>mdi-diversify</v-icon>
              {{ tur.name }}
            </h2>
            <div>
              <v-btn x-small color="info" class="mr-2" @click="urunTurDuzenleOpen(tur.code)">
                <v-icon size="16" class="mr-1">mdi-pencil</v-icon>
                {{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_TYPES_AREA.PRODUCT_TYPE_EDIT_BTN") }}
              </v-btn>
              <v-btn x-small color="error" @click="urunTurKaldirOpen(tur.code)">
                <v-icon size="16" class="mr-1">mdi-delete-outline</v-icon>
                {{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_TYPES_AREA.PRODUCT_TYPE_DELETE_BTN") }}
              </v-btn>
            </div>
          </div>
          <v-divider class="mb-3"></v-divider>
          <span :key="nitelik.code" v-for="nitelik in tur.items">
            <v-chip label class="mr-1 mb-1">
              <v-icon size="16" class="mr-1">mdi-label</v-icon>
              {{ nitelik.name }}
            </v-chip>
          </span>
        </v-card>
      </div>
    </div>

    <!-- Ürün Türü Ekle -->
    <v-dialog max-width="800" v-model="urunTuruEkle.dialog">
      <v-card>
        <v-card-title>
          <div class="d-flex align-center">
            <v-icon left color="grey darken-3">mdi-plus-box</v-icon>
            {{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_TYPES_AREA.PRODUCT_TYPE_ADD_DIALOG.TITLE") }}
          </div>
          <v-spacer></v-spacer>
          <v-btn icon @click="urunTurEkleIptal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-2">
          <v-text-field
            prepend-inner-icon="mdi-arrow-right"
            :label="$t('URUNLER.PRODUCT_PREFERENCES.PRODUCT_TYPES_AREA.PRODUCT_TYPE_ADD_DIALOG.TYPE_NAME_LABEL')"
            :hint="$t('URUNLER.PRODUCT_PREFERENCES.PRODUCT_TYPES_AREA.PRODUCT_TYPE_ADD_DIALOG.TYPE_NAME_HINT')"
            v-model="urunTuruEkle.name"
          ></v-text-field>
          <v-text-field
            prepend-inner-icon="mdi-arrow-right"
            :label="$t('URUNLER.PRODUCT_PREFERENCES.PRODUCT_TYPES_AREA.PRODUCT_TYPE_ADD_DIALOG.TYPE_DESC_LABEL')"
            v-model="urunTuruEkle.desc"
          ></v-text-field>
          <v-select
            prepend-inner-icon="mdi-arrow-right"
            :label="$t('URUNLER.PRODUCT_PREFERENCES.PRODUCT_TYPES_AREA.PRODUCT_TYPE_ADD_DIALOG.TYPE_VARIATION_LABEL')"
            :items="nitelikListesi"
            v-model="urunTuruEkle.attrs"
            multiple
            item-text="name"
            item-value="code"
          >
            <template #selection="{item}">
              <v-chip label dark color="grey darken-3">{{ item.name }}</v-chip>
            </template>
          </v-select>
          <div v-if="nitelikListesi.length">
            <draggable :list="urunTuruEkle.attrs" @start="updateAttrDrag" @end="updateAttrDrag">
              <div class="d-inline-block mb-3" :key="key" v-for="(attrCode, key) in urunTuruEkle.attrs">
                <v-chip label dark color="grey darken-3 pl-1">
                  <v-icon class="mr-1" style="opacity: .3;cursor: grab;">mdi-drag</v-icon>
                  {{ getAttr(attrCode).name }}
                </v-chip>
                <v-icon v-show="urunTuruEkle.attrs.length !== (key + 1) || dragStartOnAttrs">mdi-arrow-right-thin</v-icon>
              </div>
            </draggable>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue" class="px-3" dark @click="urunTurunuEkle" :loading="urunTuruEkle.loading">
            <v-icon class="mr-1">mdi-plus-box</v-icon>
            {{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_TYPES_AREA.PRODUCT_TYPE_ADD_DIALOG.OK_BTN") }}
          </v-btn>
          <v-btn color="red darken-2" dark @click="urunTurEkleIptal">
            <v-icon class="mr-1">mdi-cancel</v-icon>
            {{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_TYPES_AREA.PRODUCT_TYPE_ADD_DIALOG.CANCEL_BTN") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ./Ürün Türü Ekle -->

    <!-- Ürün Türü Düzenle -->
    <v-dialog max-width="800" v-model="urunTuruDuzenle.dialog">
      <v-card>
        <v-card-title>
          <div class="d-flex align-center">
            <v-icon left color="grey darken-3">mdi-pen</v-icon>
            {{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_TYPES_AREA.PRODUCT_TYPE_EDIT_DIALOG.TITLE") }}
          </div>
          <v-spacer></v-spacer>
          <v-btn icon @click="urunTurEkleIptal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-2">
          <v-text-field
            prepend-inner-icon="mdi-arrow-right"
            :label="$t('URUNLER.PRODUCT_PREFERENCES.PRODUCT_TYPES_AREA.PRODUCT_TYPE_EDIT_DIALOG.TYPE_NAME_LABEL')"
            :hint="$t('URUNLER.PRODUCT_PREFERENCES.PRODUCT_TYPES_AREA.PRODUCT_TYPE_EDIT_DIALOG.TYPE_NAME_HINT')"
            v-model="urunTuruDuzenle.name"
          ></v-text-field>
          <v-text-field
            prepend-inner-icon="mdi-arrow-right"
            :label="$t('URUNLER.PRODUCT_PREFERENCES.PRODUCT_TYPES_AREA.PRODUCT_TYPE_EDIT_DIALOG.TYPE_DESC_LABEL')"
            v-model="urunTuruDuzenle.desc"
          ></v-text-field>
          <v-select
            prepend-inner-icon="mdi-arrow-right"
            :label="$t('URUNLER.PRODUCT_PREFERENCES.PRODUCT_TYPES_AREA.PRODUCT_TYPE_EDIT_DIALOG.TYPE_VARIATION_LABEL')"
            :items="nitelikListesi"
            v-model="urunTuruDuzenle.attrs"
            multiple
            item-text="name"
            item-value="code"
          >
            <template #selection="{item}">
              <v-chip label dark color="grey darken-3">{{ item.name }}</v-chip>
            </template>
          </v-select>
          <div v-if="nitelikListesi.length">
            <draggable :list="urunTuruDuzenle.attrs" @start="updateAttrDrag" @end="updateAttrDrag">
              <div class="d-inline-block mb-3" :key="key" v-for="(attrCode, key) in urunTuruDuzenle.attrs">
                <v-chip label dark color="grey darken-3 pl-1">
                  <v-icon class="mr-1" style="opacity: .3;cursor: grab;">mdi-drag</v-icon>
                  {{ getAttr(attrCode).name }}
                </v-chip>
                <v-icon v-show="urunTuruDuzenle.attrs.length !== (key + 1) || dragStartOnAttrs">mdi-arrow-right-thin</v-icon>
              </div>
            </draggable>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" class="px-3" dark @click="urunTurunuDuzenle" :loading="urunTuruDuzenle.loading">
            <v-icon class="mr-1" size="20">mdi-refresh</v-icon>
            {{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_TYPES_AREA.PRODUCT_TYPE_EDIT_DIALOG.EDIT_BTN") }}
          </v-btn>
          <v-btn color="red darken-2" dark @click="urunTurDuzenleIptal">
            <v-icon class="mr-1">mdi-cancel</v-icon>
            {{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_TYPES_AREA.PRODUCT_TYPE_EDIT_DIALOG.CANCEL_BTN") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ./Ürün Türü Düzenle -->

    <!-- Ürün Türü Kaldir -->
    <v-dialog v-model="urunTuruKaldir.dialog" max-width="500">
      <v-card>
        <v-card-title class="headline red--text text--darken-4">
          <v-icon left color="red darken-4">mdi-close-octagon</v-icon>
          {{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_TYPES_AREA.PRODUCT_TYPE_DELETE_DIALOG.TITLE") }}
        </v-card-title>
        <v-card-text>{{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_TYPES_AREA.PRODUCT_TYPE_DELETE_DIALOG.INFO_CONTENT") }} </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="urunTuruKaldir.dialog = false">
            {{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_TYPES_AREA.PRODUCT_TYPE_DELETE_DIALOG.CANCEL_BTN") }}
          </v-btn>
          <v-btn color="green darken-1" text :loading="urunTuruKaldir.loading" @click="urunTurunuKaldir()"
            >{{ $t("URUNLER.PRODUCT_PREFERENCES.PRODUCT_TYPES_AREA.PRODUCT_TYPE_DELETE_DIALOG.OK_BTN") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ./Ürün Türü Kaldir -->
  </urun-areas-layout>
</template>

<script>
import PanelTitle from "../../../../components/PanelTitle.vue";
import ListInputs from "../../../../components/Settings/SystemSettings/ListInputs.vue";
import UrunAreasLayout from "./UrunAreasLayout.vue";
import UrunlerService from "@/services/UrunlerService";
import Draggable from "vuedraggable";
import { ref } from "@vue/composition-api";

export default {
  name: "UrunTurleri",

  components: { UrunAreasLayout, PanelTitle, ListInputs, Draggable },

  props: {
    value: {}
  },

  data: () => ({
    urunTuruEkle: {
      dialog: false,
      loading: false,
      name: "",
      desc: "",
      attrs: []
    },
    urunTuruDuzenle: {
      code: null,
      dialog: false,
      loading: false,
      name: "",
      desc: "",
      attrs: []
    },
    urunTuruKaldir: {
      code: null,
      dialog: false,
      loading: false
    },
    nitelikListesi: [],
    urunTurleriListesi: [],
    turStatus: false
  }),

  setup() {
    const nitelikListMap = {};
    const dragStartOnAttrs = ref(false);

    return {
      nitelikListMap,
      dragStartOnAttrs
    }
  },

  methods: {
    urunTurunuEkle() {
      const urunTuruAdi = this.urunTuruEkle.name,
        urunTuruNitelikleri = this.urunTuruEkle.attrs,
        urunTuruAciklamasi = this.urunTuruEkle.desc;
      this.urunTuruEkle.loading = true;
      UrunlerService.urunTuruEkle({
        urunTuruAdi,
        urunTuruNitelikleri,
        urunTuruAciklamasi
      })
        .then(res => {
          if (res.status === 200) {
            this.$snotify.success(this.$t("URUNLER.NOTIFY.PRODUCT_PREFERENCES.PRODUCT_TYPE_ADD_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
            this.getUrunTurleriListesi();
            this.urunTurEkleIptal();
            this.$emit("change");
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        })
        .then(() => {
          this.urunTuruEkle.loading = false;
        });
    },
    urunTurEkleIptal() {
      this.urunTuruEkle.dialog = false;
      this.urunTuruEkle.name = "";
      this.urunTuruEkle.desc = "";
      this.urunTuruEkle.attrs = [];
    },
    urunTurDuzenleOpen(turCode) {
      let tur = this.urunTurleriListesi.find(o => o.code === turCode);
      this.urunTuruDuzenle.name = tur.name;
      this.urunTuruDuzenle.desc = tur.desc;
      this.urunTuruDuzenle.attrs = tur.items.map(o => o.code);
      this.urunTuruDuzenle.code = turCode;
      this.urunTuruDuzenle.dialog = true;
    },
    urunTurunuDuzenle() {
      const urunTuruCode = this.urunTuruDuzenle.code,
        urunTuruAdi = this.urunTuruDuzenle.name,
        urunTuruNitelikleri = this.urunTuruDuzenle.attrs,
        urunTuruAciklamasi = this.urunTuruDuzenle.desc;

      this.urunTuruDuzenle.loading = true;
      UrunlerService.urunTuruDuzenle({
        urunTuruCode,
        urunTuruAdi,
        urunTuruNitelikleri,
        urunTuruAciklamasi
      })
        .then(res => {
          if (res.status === 200) {
            this.$snotify.success(this.$t("URUNLER.NOTIFY.PRODUCT_PREFERENCES.PRODUCT_TYPE_UPDATE_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
            this.getUrunTurleriListesi();
            this.urunTurDuzenleIptal();
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        })
        .then(() => {
          this.urunTuruDuzenle.loading = false;
        });
    },
    urunTurDuzenleIptal() {
      this.urunTuruDuzenle.dialog = false;
    },
    urunTurunuKaldir() {
      this.urunTuruKaldir.loading = true;
      UrunlerService.urunTuruKaldir(this.urunTuruKaldir.code)
        .then(res => {
          if (res.status === 200) {
            this.$snotify.success(this.$t("URUNLER.NOTIFY.PRODUCT_PREFERENCES.PRODUCT_TYPE_DELETE_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
            this.getUrunTurleriListesi();
            this.urunTuruKaldir.dialog = false;
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        })
        .then(() => {
          this.urunTuruKaldir.loading = false;
        });
    },
    urunTurKaldirOpen(turCode) {
      this.urunTuruKaldir.code = turCode;
      this.urunTuruKaldir.dialog = true;
    },
    getNitelikListesi() {
      return UrunlerService.nitelikListesi().then(res => {
        if (res.status === 200) {
          this.nitelikListesi = res.data;
        } else {
          this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
        }
      });
    },
    getUrunTurleriListesi() {
      return UrunlerService.urunTuruListesi().then(res => {
        if (res.status === 200) {
          this.urunTurleriListesi = res.data;
        } else {
          this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
        }
      });
    },
    getAttr(attrCode) {
      return this.nitelikListMap[attrCode];
    },
    updateAttrDrag(e) {
      this.dragStartOnAttrs = e.type === 'start' || false;
    }
  },

  created() {
    this.getNitelikListesi().then(() => {
      this.getUrunTurleriListesi().then(() => {
        this.turStatus = true;

        this.nitelikListesi.forEach(item => {
          this.nitelikListMap[item.code] = item;
        })
      });
    });
  }
};
</script>

<style></style>
